import React, { useState } from "react";
import { toast } from "sonner";
import { submitContact, extractErrorMessage } from "@/lib/api";
import { CONTACT_FORM } from "@/constants/testIds";
import Reveal from "../sections/Reveal";

const SUBJECTS = [
  "Speaking inquiry",
  "Advisory / Fractional CTO",
  "Press / Media",
  "Partnership",
  "Other",
];

export default function ContactForm({ initialSubject }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: initialSubject || "Advisory / Fractional CTO",
    message: "",
  });
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");
    try {
      await submitContact(form);
      setStatus("success");
      toast.success("Sent. Rakia reviews all inquiries personally.");
      setForm({ name: "", email: "", subject: form.subject, message: "" });
    } catch (err) {
      setStatus("error");
      const msg = extractErrorMessage(err);
      setErrorMsg(msg);
      toast.error(msg);
    }
  };

  return (
    <form
      data-testid={CONTACT_FORM.root}
      onSubmit={onSubmit}
      noValidate
      className="flex flex-col gap-6"
    >
      <Reveal>
        <div>
          <label htmlFor="c-name" className="rk-label">Name</label>
          <input
            id="c-name"
            type="text"
            required
            data-testid={CONTACT_FORM.nameInput}
            value={form.name}
            onChange={update("name")}
            className="rk-field"
            placeholder="Your name"
          />
        </div>
      </Reveal>
      <Reveal delay={0.05}>
        <div>
          <label htmlFor="c-email" className="rk-label">Email</label>
          <input
            id="c-email"
            type="email"
            required
            data-testid={CONTACT_FORM.emailInput}
            value={form.email}
            onChange={update("email")}
            className="rk-field"
            placeholder="you@organization.com"
          />
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div>
          <label htmlFor="c-subject" className="rk-label">Subject</label>
          <select
            id="c-subject"
            data-testid={CONTACT_FORM.subjectSelect}
            value={form.subject}
            onChange={update("subject")}
            className="rk-field rk-select"
          >
            {SUBJECTS.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <div>
          <label htmlFor="c-message" className="rk-label">Message</label>
          <textarea
            id="c-message"
            required
            data-testid={CONTACT_FORM.messageTextarea}
            value={form.message}
            onChange={update("message")}
            className="rk-textarea"
            placeholder="A few sentences on what you're working on."
          />
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="flex flex-wrap items-center gap-4 pt-2">
          <button
            type="submit"
            disabled={status === "loading"}
            data-testid={CONTACT_FORM.submit}
            className="rk-btn-primary"
          >
            {status === "loading" ? "Sending…" : "Send"}
          </button>
          <span className="rk-caption">
            Rakia reviews all messages personally. You will hear back within 3
            business days.
          </span>
        </div>
      </Reveal>
      {status === "success" && (
        <div
          data-testid={CONTACT_FORM.success}
          className="mt-2"
          style={{
            paddingTop: 14,
            borderTop: "1px solid var(--rk-copper)",
            fontSize: 15,
          }}
        >
          Received. You’ll hear back within 3 business days.
        </div>
      )}
      {status === "error" && (
        <div
          data-testid={CONTACT_FORM.error}
          style={{ color: "var(--rk-danger)", fontSize: 14 }}
        >
          {errorMsg}
        </div>
      )}
    </form>
  );
}
